import React from "react"

import {Form} from "./Form"

const BasicLayoutId = "104572af-2e23-4a52-93d8-80cfe4e99068"
function New() {
	const initialState = {
		PreviewOptions: [],
		LayoutID: BasicLayoutId,
		Locale: "en-AU",
		Tags: [],
		Text: "New SMS content",
		ForValidationPeriod: "",
		ForPreChargeOff: "",
		Archived: false,
		ID: "",
	}

	return <Form title="New SMS Template" initialState={initialState} disabled={false} />
}

export {New}
